import { MobModel } from "types";

import conwayPilotImage from "assets/mob-conway-pilot.svg";
import conwayShipImage from "assets/mob-conway-ship.svg";

import { BASE_STATS } from "data/baseStats";

const { FIREPOWER, RESILIENCE, SPEED, PRECISION, ENERGY } = BASE_STATS;

const BISHOP_LAUNCH_CHECK_MOBS: Record<string, MobModel> = {
  conway: {
    name: "Conway",
    images: {
      ship: conwayShipImage,
      pilot: conwayPilotImage,
    },
    dialogs: {
      opening:
        "Hey there, champ. Before you venture out into the vast universe, let's review the battle mechanics you learned at the academy. Afterwards, we'll get you set up with a few ship upgrades.",
      win: "We've issued you a set of ship upgrades designed specifically for your ship. Go on ahead to Bishop City to get those upgrades installed. You're ready to go out there and explore!",
      lose: "We've issued you a set of ship upgrades designed specifically for your ship. Go on ahead to Bishop City to get those upgrades installed. You're ready to go out there and explore! ...Ready-ish, at least.",
      tutorial: {
        preview:
          "Before a battle, analyze how your stats and skills compare with your opponent. If you win, you will receive rewards based on your battle rating, which depends on how soundly you defeat your opponent.",
        fight: [
          "That green bar to the top left is your ship health. If it goes to zero first, you lose the battle.",
          "Those colorful bars on the bottom show you the how weakened each ship's parts are during battle, which affect its corresponding stat. Example: Weakened weapons mean less firepower. These are fully restored after every battle.",
          "Above that is your fight actions bar. You can hover over each button to see details. The first five buttons are regular attacks, each targeting a specific ship part.",
          "Next are your pilot skills, which have recharge periods after use. Head to the Loadout Hub in the city when you're ready to learn more skills.",
          "The red button at the end is to attempt an escape.",
          "Lastly, at the top right you'll see the combat log, which you can toggle open or closed.",
          "And that's it! Let's battle!",
        ],
        winResults:
          "When you win in battle, which you did this time, you gain medallions and credits. The higher your battle rating, the better your rewards. When you lose in battle, you're sent to the nearest Loadout Hub for repairs.",
        loseResults:
          "When you lose in battle, which you did this time, you'd normally be sent to the nearest Loadout Hub for repairs. But this is a review, so we'll repair your ship here for free. When you win in battle, you gain medallions and credits. The higher your battle rating, the better your rewards.",
      },
    },
    position: 70,
    heightPercentage: 30,
    medallions: 0,
    baseStatsModifiers: {
      firepower: 3,
      resilience: 3,
      speed: 3,
      precision: 3,
      energy: 3,
    },
    baseStatsCosts: {
      firepower: 2,
      resilience: 2,
      speed: 2,
      precision: 2,
      energy: 2,
    },
    baseStatsTargets: [PRECISION, RESILIENCE, FIREPOWER, SPEED, ENERGY],
    isBoss: false,
    isTutorial: true,
    drops: {},
    installedUpgrades: {
      weapons: null,
      shields: null,
      thrusters: null,
      targetingSystem: null,
      reactorCore: null,
    },
    partPositions: {
      weapons: { x: 60.5, y: 56.5 },
      targeting: { x: 70.5, y: 56.5 },
      thrusters: { x: 24, y: 50.75 },
    },
    skills: [],
  },
};

export default BISHOP_LAUNCH_CHECK_MOBS;
